/* eslint-disable no-useless-catch */
import { serialize } from 'utils/crud';

import { FindOneOptions } from './common';
import { entityService } from './services';
// #endregion Local Imports

const pathname = '/bills';

export const BillApi = {
  create: async (body: any) => {
    try {
      const response = await entityService.post(pathname, body);

      return response.data;
    } catch (error) {
      throw error;
    }
  },

  createDraftBill: async (body: any = {}) => {
    const url = `${pathname}/draft`;

    try {
      const response = await entityService.post(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  createBill: async (body: any = {}) => {
    const url = `${pathname}`;

    try {
      const response = await entityService.post(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  createReturnBill: async (billID: string, body: any = {}) => {
    const url = `${pathname}/${billID}/return`;

    try {
      const response = await entityService.post(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },
  exportCustomerBills: async (option: any) => {
    let url = `${pathname}/export-customer`;

    const { billIDs, entityIDs, ...newOption } = option;
    const query = serialize(newOption);
    url += query;

    try {
      const response = await entityService.post(url, {
        billIDs,
        entityIDs,
      });

      return response;
    } catch (error) {
      throw error;
    }
  },
  exportSupplierBills: async (option: any) => {
    let url = `${pathname}/export-supplier`;

    const { billIDs, entityIDs, ...newOption } = option;
    const query = serialize(newOption);
    url += query;

    try {
      const response = await entityService.post(url, {
        billIDs,
        entityIDs,
      });

      return response;
    } catch (error) {
      throw error;
    }
  },
  find: async (option: FindOneOptions) => {
    let url = pathname;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findOne: async (id: string) => {
    const url = `${pathname}/${id}`;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  checkCanUpdate: async (id: string) => {
    const url = `${pathname}/${id}/check-can-update`;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  checkCanReject: async (id: string) => {
    const url = `${pathname}/${id}/check-can-reject`;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  checkCanReturn: async (id: string) => {
    const url = `${pathname}/${id}/check-can-return`;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findOneDebt: async (id: string | undefined) => {
    const url = `${pathname}/debt/${id}`;
    // const query = serialize(option);
    // url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },
  findOneToCollectDebt: async (billID: string) => {
    const url = `${pathname}/${billID}/collect-debt`;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },
  findCollaboratorDebt: async (option: any) => {
    let url = `${pathname}/collaborator-debt`;

    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);
      return response;
    } catch (error) {
      throw error;
    }
  },
  findCustomerDebt: async (option: any) => {
    let url = `${pathname}/customer-debt`;

    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);
      return response;
    } catch (error) {
      throw error;
    }
  },
  findDebt: async (option: any) => {
    let url = `${pathname}/debt`;

    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);
      return response;
    } catch (error) {
      throw error;
    }
  },
  findBillToUpdate: async (id: string) => {
    const url = `${pathname}/${id}/update`;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },
  findCustomerBills: async (option: any) => {
    let url = `${pathname}/customer`;

    const {
      startedAt,
      finishedAt,
      supplierIDs,
      customerIDs,
      collaboratorIDs,
      ...newOption
    } = option;
    const query = serialize(newOption);
    url += query;

    try {
      const response = await entityService.post(url, {
        startedAt,
        finishedAt,
        supplierIDs,
        customerIDs,
        collaboratorIDs,
      });

      return response;
    } catch (error) {
      throw error;
    }
  },
  findSupplierBills: async (option: any) => {
    let url = `${pathname}/supplier`;

    const {
      startedAt,
      finishedAt,
      supplierIDs,
      customerIDs,
      collaboratorIDs,
      ...newOption
    } = option;
    const query = serialize(newOption);
    url += query;

    try {
      const response = await entityService.post(url, {
        startedAt,
        finishedAt,
        supplierIDs,
        customerIDs,
        collaboratorIDs,
      });

      return response;
    } catch (error) {
      throw error;
    }
  },
  findCollaboratorBills: async (option: any) => {
    let url = `${pathname}/collaborator`;

    const {
      startedAt,
      finishedAt,
      supplierIDs,
      customerIDs,
      collaboratorIDs,
      ...newOption
    } = option;
    const query = serialize(newOption);
    url += query;

    try {
      const response = await entityService.post(url, {
        startedAt,
        finishedAt,
        supplierIDs,
        customerIDs,
        collaboratorIDs,
      });

      return response;
    } catch (error) {
      throw error;
    }
  },
  findReturnBills: async (option: any) => {
    let url = `${pathname}/return`;

    const {
      startedAt,
      finishedAt,
      supplierIDs,
      customerIDs,
      collaboratorIDs,
      ...newOption
    } = option;
    const query = serialize(newOption);
    url += query;

    try {
      const response = await entityService.post(url, {
        startedAt,
        finishedAt,
        supplierIDs,
        customerIDs,
        collaboratorIDs,
      });

      return response;
    } catch (error) {
      throw error;
    }
  },
  findDebtGroupByCustomer: async (option: any) => {
    let url = `${pathname}/group-by-customer`;

    const {
      startedAt,
      finishedAt,
      supplierIDs,
      customerIDs,
      collaboratorIDs,
      ...newOption
    } = option;
    const query = serialize(newOption);
    url += query;

    try {
      const response = await entityService.post(url, {
        startedAt,
        finishedAt,
        supplierIDs,
        customerIDs,
        collaboratorIDs,
      });

      return response;
    } catch (error) {
      throw error;
    }
  },
  findDebtGroupBySupplier: async (option: any) => {
    let url = `${pathname}/group-by-supplier`;

    const {
      startedAt,
      finishedAt,
      supplierIDs,
      customerIDs,
      collaboratorIDs,
      ...newOption
    } = option;
    const query = serialize(newOption);
    url += query;

    try {
      const response = await entityService.post(url, {
        startedAt,
        finishedAt,
        supplierIDs,
        customerIDs,
        collaboratorIDs,
      });

      return response;
    } catch (error) {
      throw error;
    }
  },
  findDebtGroupByCollaborator: async (option: any) => {
    let url = `${pathname}/group-by-collaborator`;

    const {
      startedAt,
      finishedAt,
      supplierIDs,
      customerIDs,
      collaboratorIDs,
      ...newOption
    } = option;
    const query = serialize(newOption);
    url += query;

    try {
      const response = await entityService.post(url, {
        startedAt,
        finishedAt,
        supplierIDs,
        customerIDs,
        collaboratorIDs,
      });

      return response;
    } catch (error) {
      throw error;
    }
  },
  findCollaboratorDebtGroupByCustomer: async (option: any) => {
    let url = `${pathname}/collaborator/group-by-customer`;

    const {
      startedAt,
      finishedAt,
      supplierIDs,
      customerIDs,
      collaboratorIDs,
      ...newOption
    } = option;
    const query = serialize(newOption);
    url += query;

    try {
      const response = await entityService.post(url, {
        startedAt,
        finishedAt,
        supplierIDs,
        customerIDs,
        collaboratorIDs,
      });

      return response;
    } catch (error) {
      throw error;
    }
  },

  findCollaboratorDebtGroupByCustomerToCollectDebt: async (option: any) => {
    let url = `${pathname}/collaborator/group-by-customer/collect-debt`;

    const {
      startedAt,
      finishedAt,
      supplierIDs,
      customerIDs,
      collaboratorIDs,
      ...newOption
    } = option;
    const query = serialize(newOption);
    url += query;

    try {
      const response = await entityService.post(url, {
        startedAt,
        finishedAt,
        supplierIDs,
        customerIDs,
        collaboratorIDs,
      });

      return response;
    } catch (error) {
      throw error;
    }
  },

  findCollaboratorDebtGroupBySupplier: async (option: any) => {
    let url = `${pathname}/collaborator/group-by-supplier`;

    const {
      startedAt,
      finishedAt,
      supplierIDs,
      customerIDs,
      collaboratorIDs,
      ...newOption
    } = option;
    const query = serialize(newOption);
    url += query;

    try {
      const response = await entityService.post(url, {
        startedAt,
        finishedAt,
        supplierIDs,
        customerIDs,
        collaboratorIDs,
      });

      return response;
    } catch (error) {
      throw error;
    }
  },

  checkBillItemQuantity: async (body: any) => {
    const url = `${pathname}/check-bill-item-quantity`;

    try {
      const response = await entityService.patch(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  checkReturnBillItemQuantity: async (billID: string, body: any) => {
    const url = `${pathname}/${billID}/return/check-bill-item-quantity`;

    try {
      const response = await entityService.patch(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  rejectBill: async (id: string, body: any = {}) => {
    const url = `${pathname}/${id}/reject`;

    try {
      const response = await entityService.patch(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  update: async (id: string, body: any = {}) => {
    const url = `${pathname}/${id}`;

    try {
      const response = await entityService.patch(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  updateBill: async (id: string, body: any = {}) => {
    const url = `${pathname}/${id}/update`;

    try {
      const response = await entityService.post(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  delete: async (id: string) => {
    const url = `${pathname}/${id}`;

    try {
      const response = await entityService.delete(url);
      return response;
    } catch (error) {
      throw error;
    }
  },
};
